import React from 'react';
import { Ticket, X } from '@phosphor-icons/react';
import { Button, Modal, notify } from 'app/components';
import { markListingAsSold } from '../api'
import { analyticEventLogger } from '../../../utils/commonUtils';
import { TICKET_MARK_AS_SOLD_EVENT_CLICK } from '../../../constants/eventLogger';
import mixpanel from 'mixpanel-browser';

const MarkSoldModal = ({ onClose, listingId, ticket }) => {
  const handleConfirm = () => {
    analyticEventLogger(TICKET_MARK_AS_SOLD_EVENT_CLICK);
    markListingAsSold(listingId, () => {
      mixpanel.track("Listing_Marked_As_Sold", {
      "event_id": ticket?.event?.id,
      "event_name": ticket?.event?.payload?.name,
      // "category_name": categoryName,
      "ticket_price": ticket?.ticketPrice,
      "ticket_quantity": ticket?.tickets,
      "user_id": ticket?.user,
      "listing_status": "Sold",
      "page_url": window.location.href,
      });
      onClose();
      notify('success', 'Listing marked as sold', {
        position: 'bottom-center',
        duration: 2000,
      });
    }, () => {
      notify('error', 'Failed to mark listing as sold', {
        position: 'bottom-center',
        duration: 2000,
      });
    });
  };

  return (
    <Modal
      secondaryText='Mark as sold'
      className='mark-sold-modal'> 
      <div className='flex justify-between'>
        <Ticket size='32'/>
        <X size='24'
          onClick={onClose}/>
      </div>
      <div className='heading-24 pt-5'>Are you sure you want to mark the listing as sold?</div>
      <div className='flex md:justify-between md:flex-row md:py-4 pt-4 py-2 md:gap-5 flex-col-reverse gap-2 w-full '>
        <Button
          type='tertiary'
          onClick={onClose}
          className='w-full'
        >Cancel</Button>
        <Button
          type='primary-black'
          onClick={handleConfirm}
          className='w-full'
        >Mark as sold</Button>
      </div>
    </Modal>
  )
}

export default MarkSoldModal